<!--
 * @Description: 注册数变化趋势组件
 * @Author:sunhuihong
 * @Date: 2022-07-14 08:33:29
 * @LastEditTime: 2022-07-14 17:33:29
-->
<template>
  <div class="register-trend-charts">
    <div class="register-trend-charts-header">
      <span style="font-weight: 600; color: #333333;">注册数变化趋势</span>
      <div class="tabs">
        <span @click="changeTabs(item)" v-for="item in registerTrendHeaderData" :key="item.id" 
          :class="registerTabsIndex == item.id ? 'active-tabs' : 'defaut-active'">
          {{item.name}}
        </span>
      </div>
    </div>
    <div style="width: 100%; height: 300px"  :id="id" class="echarts" ref="echarts"></div>
  </div>
</template>
<script>
export default {
  name: 'RegisterTrendCharts',
  props: ['id', 'registerChartData', "registerTabsIndex", "registerTrendHeaderData"],
  data() {
    return {
    }
  },
  
  mounted() {
    this.drawCharts();
  },

  watch: {
    //子组件监听父组件数据实时更新
    registerChartData: {
      handler(_newValue, _oldValue) {
        this.drawCharts();
      },
      deep: true
    }
  },

  methods: {
    changeTabs(item) {
      if (this.registerTrendHeaderData.length == 1) return;
      this.$emit("handle-register-tabs", item)
    },

    drawCharts() {
      let maxYAxis =  Math.ceil(this.registerChartData.registerNum.reduce((a, b) => a > b ? a : b)*1.2);
      let chart = this.echarts.init(document.getElementById(this.id));
        chart.setOption({
          tooltip: {
          trigger: 'axis',
          backgroundColor: "rgba(255,255,255,0.9000)", 
          borderColor: '#D7DDE5', // 提示框浮层的边框颜色。
          borderWidth: 1, // 提示框浮层的边框宽。
          padding: [5, 18],
          textStyle : {
            color: '#333333' ,
            align:'left'
          },
          formatter:function(params){
            let relVal = '';
            relVal += `<div>${params[0].axisValue}</div>`;
            for (let i = 0, l = params.length; i < l; i++) { 
              relVal += '<br/>' + params[i].seriesName + ':' + ' ' + params[i].value
            }
            return relVal;
          }
        },
        grid: {
		        left: '30',
		        right: '20',
		        bottom: '30',
		        containLabel: true
		    },
        legend: [{
          top: "18",
          right: "63",
          itemWidth: 7,
          itemHeight: 8,
          data: [
            {
              name: '注册数',
              textStyle: {
                fontSize: 14,
                color: '#333333',
              },
              icon: 'rect',
            },
          ]
        }],
        xAxis: [
          {
            type: 'category',
            data: this.registerChartData.axiData,
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate: this.registerChartData.axiData.length > 10 ? 45 : 0,//倾斜度 -90 至 90 默认为0
              margin: 8,
              textStyle: {
                fontWeight: "normal",
                color: "#666666"
              }
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#3AC9EA'
              },
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            minInterval: 1,
            name: '人',
            nameTextStyle: {
            padding: [0, 0, 10, -35]    // 四个数字分别为上右下左与原位置距离
            },
            min: 0,
            max: maxYAxis,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        dataZoom: [
          { //Y轴固定,让内容滚动
            handleSize: 0,//滑动条的 左右2个滑动条的大小
            height: 5,//组件高度
            left: 50, //左边的距离
            right: 40,//右边的距离
            bottom: 16,//右边的距离
            handleColor: '#ddd',//h滑动图标的颜色
            handleStyle: {
              borderColor: "#cacaca",
              borderWidth: "1",
              shadowBlur: 2,
              background: "#ddd",
              shadowColor: "#ddd",
            },
            showDetail: false,
            fillerColor : '#A3A3A3',
            backgroundColor: '#ddd',//两边未选中的滑动条区域的颜色
            showDataShadow: false,//是否显示数据阴影 默认auto
            show: this.registerChartData.axiData.length > 14 ? true : false,
            xAxisIndex: [0],
            type: 'slider', // 这个 dataZoom 组件是 slider 型 dataZoom 组件
            startValue: 0, // 从头开始。
            endValue: 14, // 一次性展示15个。
            zoomLock: true, //锁定区域禁止缩放(鼠标滚动会缩放,所以禁止)
          },
          {
            type: 'inside',
            xAxisIndex: [0],
            start: 0,
            end: 14,
            zoomLock: true, //锁定区域禁止缩放
          },
        ],
        series: [
          {
            name: '注册数',
            type: 'bar',
            barWidth : 15,
            //颜色  
            itemStyle: {  
              normal: {  
                color: '#3E7EF5',  
              }  
            },  
            data: this.registerChartData.registerNum,
          },
        ] 
      })
        window.addEventListener('resize', function () {
          chart.resize();
      });
    },
  }
}
</script>
<style  scoped>
.register-trend-charts {
  height: 344px;
  border-radius: 6px;
  border: 1px solid #D7DDE5;
}

.register-trend-charts-header {
  display: flex;
  justify-content: space-between;
  height: 46px;
  line-height: 46px;
  padding: 0 20px;
  border-bottom: 1px solid #D7DDE5;
}

.tabs :nth-child(1) {
  margin-right: 30px;
}

.active-tabs {
  font-size: 16px;
  color: #3E7EF5;
  display: inline-block;
  height: 38px;
  border-bottom: 3px solid #3E7EF5;
  cursor: pointer;
}

.defaut-active {
  font-size: 16px;
  color: #666666;
  display: inline-block;
  height: 44px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/overview/components/RegisterTrendCharts.vue